// React
import { useContext, useState } from "react"

// Third-Party Libraries
import toast from "react-hot-toast"

// Types
import type { FormatType, HeaderListType } from "../../types"

// Utils
import { DataContext } from "../../contexts"

export function useDataFormat(): FormatType {
  // Hooks
  const { list } = useContext(DataContext)
  const [tab, setTab] = useState<number>(0)
  const [headers, setHeaders] = useState<HeaderListType[]>(list.filter(item => item.required))

  const assignHeaders = (headers: HeaderListType[]): void => {
    if (!headers.length) {
      toast.error("No headers selected")
      return
    }

    setHeaders(headers)
    nextTab()
  }

  const nextTab = (): void => {
    setTab(prev => prev + 1)
  }

  const prevTab = (): void => {
    if (tab === 1) {
      setTab(prev => prev - 1)
      return
    }
  }

  return { headers, tab, assignHeaders, nextTab, prevTab }
}